import React from 'react';
import './Footer.css';
import { 
  FaEnvelope, 
  FaPhoneAlt, 
  FaTelegram,   
  FaInstagram, 
  FaYoutube, 
  FaMapMarkerAlt
} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer-new">
      <div className="footer-new-container">
        
        {/* Левая брендовая колонка (Аналог JETCAR из скрин 2) */}
        <div className="footer-new-brand-col">
          <h2 className="footer-new-logo">PREMIUM AUTO</h2>
          <p className="footer-new-desc">
            Эксклюзивный импортер BMW в Узбекистане.
            Официальный дистрибьютор Nissan в Узбекистане.
            Авторизованный сервисный партнер Rolls-Royce в Узбекистане.
          </p>
          <div className="footer-new-socials">
            <a href="https://t.me/bmwuzpa" target="_blank" rel="noreferrer" className="social-circle"><FaTelegram /></a>
            <a href="https://www.instagram.com/bmwuz/" target="_blank" rel="noreferrer" className="social-circle"><FaInstagram /></a>
            <a href="https://www.youtube.com/@BMWUzbekistanPA" target="_blank" rel="noreferrer" className="social-circle"><FaYoutube /></a>
          </div>

            {/* Единый Email */}
            <div className="contact-sub-item mail-top-border">
              <a href="mailto:bmw.uz@bmw.uz" className="contact-email">
                <FaEnvelope /> info@bmw.uz
                <br />
                <FaEnvelope /> @nissan.uz
              </a>
            </div>
        </div>

        {/* Разделительная черта как на скриншоте 2 */}
        <div className="footer-new-divider"></div>

        {/* Колонка КОМПАНИЯ */}
        <div className="footer-new-links-col">
          <h3>КОМПАНИЯ</h3>
          <ul className="footer-new-list">
            <li><a href="/">Главная</a></li>
            <li><a href="#Our_charaty_program">О нас</a></li>
            {/* <li><a href="#">Вакансии</a></li> */}
            <li>
              {/* Информация о валютах бережно перенесена сюда */}
              <div className="footer-new-exchange">
                <span>Скоро здесь появится актуальный курс валют.</span>
                {/* <span className="ex-title">Курс валют на 07.05.2026:</span> */}
                {/* <span>EUR/USD = 51.79</span> */}
                {/* <span>USD/USZ = 44.09</span> */}
              </div>
            </li>
          </ul>
        </div>

        {/* Колонка УСЛУГИ */}
        <div className="footer-new-links-col">
          <h3>УСЛУГИ</h3>
          <ul className="footer-new-list">
            <li><a href="/visit_showroom">Онлайн-запись на визит в шоурум</a></li>
            <li><a href="/test-drive-appointment">Онлайн-запись на тест-драйв</a></li>
            <li><a href="/service-appointment">Онлайн-запись на сервис</a></li>
            {/* <li><a href="#">Заказ оригинальных запчастей</a></li> */}
          </ul>
        </div>

        {/* Колонка КОНТАКТЫ (Объединяет Шоурум и Сервис со скриншота 1) */}
        <div className="footer-new-contacts-col">
          <h3>КОНТАКТЫ</h3>
          <div className="footer-new-contact-block">
            
            {/* Секция Шоурум */}
            <div className="contact-sub-item">
              <span className="contact-badge">Шоурум:</span>
              <a href="tel:+998555018877" className="contact-phone"> +998 55 501 88 77</a>
              <a href="tel:+998909768877" className="contact-phone"> +998 90 976 88 77</a>
              <p className="contact-text"> г. Ташкент Мирабадский район, ул. Авлио Ота 128</p>
              <p className="contact-text-sub">Пн - Вс, 10:00 - 19:00</p>
              <div className="contact-maps-inline">
                <a href="https://www.google.com/maps/place/%22Premium+Auto%22/@41.2891387,69.2806359,19.24z/data=!4m6!3m5!1s0x38ae5e5555a148e7:0xcc4390d552491cbb!8m2!3d41.2888602!4d69.2810554!16s%2Fg%2F11b7qctf9k?entry=ttu&g_ep=EgoyMDI2MDcxNS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer">Google Maps</a>
                <a href="https://yandex.uz/maps/10335/tashkent/?ll=69.281112%2C41.288841&mode=poi&poi%5Bpoint%5D=69.281213%2C41.288841&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D126436150045&z=20.2" target="_blank" rel="noreferrer">Yandex Maps</a>
              </div>
            </div>

            {/* Секция Сервис */}
            <div className="contact-sub-item">
              <span className="contact-badge">Сервис:</span>
              <a href="tel:+998555018877" className="contact-phone">+998 55 501 88 77</a>
              <a href="tel:+998901868877" className="contact-phone">+998 90 186 88 77</a>
              <p className="contact-text">г. Ташкент Бектемирский район ул. Туёна 10</p>
              <p className="contact-text-sub">Пн - Вс, 09:00 - 18:00</p>
              <div className="contact-maps-inline">
                <a href="https://www.google.com/maps/place/BMW+Service+Uzbekistan/@41.2418574,69.3374694,19.54z/data=!4m6!3m5!1s0x38ae5ff69ba3218f:0xe7e213ba5178689c!8m2!3d41.2418345!4d69.3375715!16s%2Fg%2F11mclfxdv2?entry=ttu&g_ep=EgoyMDI2MDcxNS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer">Google Maps</a>
                <a href="https://yandex.uz/maps/10335/tashkent/?ll=69.337630%2C41.241671&mode=poi&poi%5Bpoint%5D=69.337625%2C41.241850&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D11761388590&z=19.96" target="_blank" rel="noreferrer">Yandex Maps</a>
              </div>
            </div>



          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;